import React from "react";
import { Modal, ModalHeader, ModalFooter, Button } from "@netapp/bxp-design-system-react";
import {ModalContent} from "./Modal";
import ExternalLink from "../../../components/widgets/ExternalLink";
import {SupportMonochromeIconsIcon as Support} from "@netapp/bxp-design-system-react/icons/monochrome";
import commonStyles from "../styles/common.module.scss";
import styles from "./SupportModal.module.scss";

export default ({target, closeTrigger}) => {
    return (
        <Modal>
            <ModalHeader>
                <div className={styles["modal-header"]}>
                    <Support className={commonStyles["support-icon"]}/>
                    <span>Cloud Volumes Service Support Help</span>
                </div>
            </ModalHeader>
            <ModalContent>
                For general service questions, open a support ticket from Administration -> Support or submit a request through the <ExternalLink href={"https://mysupport.netapp.com/site/help"} newTab>NetApp Support Site</ExternalLink>. For technical support for your Cloud Volumes Service volume, open a ticket using your 20-digit serial number which starts with 930. You can find the serial number on the Cloud Volumes Service support tab.
                Please be sure to activate your CVS serial number for support from the CVS User Interface. Those steps are explained
                <ExternalLink className={styles["redirect"]} href={"https://register.netapp.com"} newTab>HERE</ExternalLink>.
            </ModalContent>
            <ModalFooter>
                <Button onClick={closeTrigger}>Close</Button>
            </ModalFooter>
        </Modal>
    );
};
